module.exports = __webpack_public_path__ + "static/media/science2.23415bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science2.jpg
// module id = 583
// module chunks = 0